export default {
	collaboration: {
		INVITED_PROJECT_MEMBERS: 'Invited project members',
		CLICKED_LOGIN_FOR_SHARED_PROJECT: 'Clicked login for shared project',
		CLICKED_REGISTER_FOR_SHARED_PROJECT: 'Clicked register for shared project',
		PROJECT_MEMBER_ROLE_EDITED: 'Changed project member role',
		MANAGER_SEAT_REQUESTED_FOR_OTHERS: 'Requested owner for manager seat (for others)',
		MANAGER_PERMISSIONS_UPGRADE_REQUESTED: 'Requested for upgraded permissions',
		DOWNLOAD_PERMISSIONS_CHANGED: 'Changed download permissions',
		COMMENTS_PERMISSIONS_CHANGED: 'Changed comments permissions'
	},
	subscription: {
		SUBSCRIPTION_REACTIVATED: 'Reactivated a cancelled subscription'
	},
	workspace: {
		WORKSPACE_DELETED: 'Deleted a workspace',
		WORKSPACE_OWNERSHIP_TRANSFERRED: 'Transferred ownership of a workspace',
		WORKSPACE_MEMBER_INVITED: 'Workspace member invited',
		WORKSPACE_ROLE_EDITED: 'Edited the role of a workspace member',
		WORKSPACE_BILLING_EDITED: 'Edited billing information',
		INVOICE_OPENED: 'Invoice opened',
		PROJECT_ACCESSED_AS_MANAGER: 'Accessed project as manager',
		WORKSPACE_LOGO_UPLOADED: 'Uploaded workspace logo',
		WORKSPACE_LOGO_RESTORED: 'Restored workspace logo'
	},
	project: {
		PROJECT_CREATED: 'Project created',
		PROJECT_DOWNLOADED: 'Downloaded a project',
		PROJECT_DELETED: 'Deleted a project',
		PROJECT_HIDDEN: 'Hid a project',
		PROJECT_UNHIDDEN: 'Unhid a project',
		PROJECT_FILTERED: 'Filter applied to projects',
		PROJECT_SEARCHED: 'Searched projects',
		PROJECT_CUSTOM_SORTED: 'Custom sorted projects',
		PROJECT_SORTED: 'Changed projects sort',
		PROJECT_FLAGGED: 'Added red flag to a project',
		PROJECT_UNFLAGGED: 'Removed red flag from a project',
		PROJECT_LINK_SHARED: 'Project share link copied',
		PROJECT_NOTIFICATIONS_MUTED_STATUS_CHANGED: 'Project notification on/off',
		PROJECT_PINNED: 'Pinned project in side navigation panel',
		PROJECT_UNPINNED: 'Unpinned project in side navigation panel',
		PROJECT_NEW_ITEM_BUTTON_CLICKED: 'Clicked new item button'
	},
	assets: {
		ASSETS_UPLOADED: 'Assets uploaded',
		ASSET_FLAGGED: 'Added red flag to an asset',
		ASSET_UNFLAGGED: 'Removed red flag from an asset',
		ASSET_APPROVED_ASSET_VIEW: 'Approved an asset from Assets View',
		ASSET_DISAPPROVED_ASSET_VIEW: 'Disapproved an asset from Asset View',
		ASSET_APPROVED_MARKUP_VIEW: 'Approved an asset from Markup View',
		ASSET_DISAPPROVED_MARKUP_VIEW: 'Disapproved an asset from Markup View',
		ASSET_DOWNLOADED: 'Downloaded an asset image',
		ASSETS_DOWNLOADED: 'Downloaded multiple asset images',
		ASSET_MARKUPS_DOWNLOADED: 'Downloaded asset markups',
		ASSET_DELETED: 'Deleted an asset',
		ASSETS_SORTED: 'Changed assets sort',
		ASSETS_FILTERED: 'Changed assets filter',
		ASSETS_SEARCHED: 'Searched assets',
		ASSETS_CUSTOM_SORTED: 'Custom sorted assets',
		ASSET_COMPARE_ROUNDS_SIDE_BY_SIDE: 'Compare rounds side by side',
		ASSET_SHOW_PREVIOUS_ROUND: 'Show previous round',
		ITEMS_MOVED_WITH_FOLDER_TREE: 'Moved items with folder tree',
		ASSETS_FLAT_VIEW_TOGGLED: 'Clicked view all assets mode'
	},
	commentsAndMarkups: {
		COMMENT_CREATED: 'Created comment',
		COMMENT_DELETED: 'Deleted comment',
		COMMENT_EDITED: 'Edited comment',
		COMMENT_APPROVED: 'Approved comment',
		COMMENTS_FILTERED: 'Filtered comments',
		BATCH_COMMENT_CREATED: 'Created batch comment',
		BATCH_COMMENTS_MARKED_AS_RESOLVED: 'Batch resolve comments'
	},
	imageTools: {
		COMPARE_ROUNDS_OPENED: 'Opened compare rounds',
		MOVED_TO_PREVIOUS_ROUND: 'Moved to a previous round',
		ASSET_IMAGE_ZOOMED: 'Asset image zoomed'
	},
	notification: {
		NOTIFICATIONS_PANEL_OPENED: 'Opened notifications panel',
		NOTIFICATION_PROJECT_OPENED: 'Opened project for a particular notification',
		NOTIFICATION_FOLDER_OPENED: 'Opened folder for a particular notification',
		NOTIFICATION_OPENED: 'Opened a particular notification',
		NOTIFICATION_SETTINGS_OPENED_FROM_PANEL: 'Opened notification settings from notifications panel'
	},
	task: {
		TASK_ASSIGNED_TO_USER: 'Assigned task to user',
		TASK_ASSIGNED_TO_MYSELF: 'Assigned task to myself',
		TASK_COMPLETED: 'Marked a task as completed'
	},
	access: {
		LOGGED_IN: 'Logged in',
		LOGGED_OUT: 'Logged out',
		SIGNED_UP: 'Signed up',
		SIGNED_UP_FROM_INVITATION: 'Signed Up from Email Invitation'
	},
	folder: {
		FOLDER_CREATED: 'Folder created'
	},
	overview: {
		OVERVIEW_PANEL_OPENED: 'Opened overview panel',
		OVERVIEW_PANEL_TAB_CHANGED: 'Changed overview panel tab',
		OVERVIEW_LABEL_CLICKED: 'Clicked overview label',
		OVERVIEW_ASSIGNEE_CLICKED: 'Clicked overview assignee'
	},
	sharing: {
		OPENED_SHARED_PROJECT: 'Opened shared project',
		OPENED_SHARED_FOLDER: 'Opened shared folder'
	},
	nac: {
		GUEST_LINK_SETTINGS_CHANGED: 'Guest link settings changed',
		GUEST_LINK_COPIED: 'Guest link copied',
		GUEST_LINK_OPENED: 'Guest link opened',
		CREDENTIALS_PROMPT_COMPLETED: 'Credentials prompt completed'
	},
	addOns: {
		ADD_ON_BOUGHT: 'Bought member or storage add on'
	},
	onboardingThumbnails: {
		MAIN_DASHBOARD_ONBOARDING_THUMBNAILS_CLOSED: 'Closed main dashboard thumbnails',
		MAIN_DASHBOARD_ONBOARDING_THUMBNAIL_CLICKED: 'Clicked main dashboard thumbnail',
		MAIN_DASHBOARD_ONBOARDING_THUMBNAIL_LINK_CLICKED: 'Clicked main dashboard thumbnail link',
		PROJECT_ONBOARDING_THUMBNAILS_CLOSED: 'Closed project view thumbnails',
		PROJECT_ONBOARDING_THUMBNAIL_CLICKED: 'Clicked project dashboard thumbnail',
		PROJECT_ONBOARDING_THUMBNAIL_LINK_CLICKED: 'Clicked project dashboard thumbnail link'
	},
	uploads: {
		ADVANCE_UPLOADS_LEARN_MORE_CLICKED: 'Clicked learn more in Advanced Uploads modal',
		ADVANCE_UPLOADS_CANCEL_CLICKED: 'Cancel Upload in Advanced Uploads modal',
		ADVANCE_UPLOADS_CONTINUE_CLICKED: 'Continue Upload in Advanced Uploads modal'
	},
	labels: {
		ADDED_LABEL: 'Added label',
		REMOVED_LABEL: 'Removed label'
	},
	assignees: {
		ADDED_ASSIGNEE: 'Added assignee to asset',
		REMOVED_ASSIGNEE: 'Removed assignee from asset'
	},
	paywall: {
		CLICKED_PAYWALL_CHIP: 'Clicked paywall chip'
	},
	dropbox: {
		CLICKED_IMPORT_FROM_DROPBOX: 'Clicked import from Dropbox',
		IMPORTED_FILES_FROM_DROPBOX: 'Imported files from Dropbox',
		FINISHED_IMPORTING_FILES_FROM_DROPBOX: 'Finished importing files from Dropbox'
	},
	onboarding: {
		ONBOARDING_COMPLETED: 'Completed onboarding flow',
		ONBOARDING_PERSONAL_INFO_COMPLETED: 'Completed personal info step only'
	},
	userMetrics: {
		CLICKED_SHOW_ANALYTICS_BUTTON: 'Clicked show analytics button',
		COPIED_LINK_IN_ANALYTICS_PANEL: 'Copied link in analytics panel',
		OPENED_ANALYTICS_PANEL_LINK: 'Opened analytics panel link',
		CLICKED_FRILL_BUTTON: 'Clicked on Frill button'
	}
};
